import React from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { IconChevronRight } from '@tabler/icons-react';

import type { MenuLink } from '../../types';

interface MenuCTAProps {
  ctaLink?: MenuLink;
  ctaTitle?: string;
  open: boolean;
}

export const MenuCTA: React.FC<MenuCTAProps> = ({ ctaLink, ctaTitle, open }) => {
  if (!ctaLink?.name || !ctaLink?.href) return null;

  return (
    <Col
      className={cn(
        'w-full px-6 py-4 transition-opacity duration-300 ease-linear',
        open ? 'opacity-100 delay-300' : 'opacity-0',
      )}
    >
      <Row
        href={ctaLink.href}
        aria-label={ctaLink.name}
        analyticsName={`cosmos-landing-page-v2-menu-cta-link-${ctaLink.name}`}
        className="items-center justify-between rounded-2xl bg-od-bg-secondary px-5 py-4 no-underline"
      >
        <Col>
          {ctaTitle && (
            <Text as="span" className="block text-label-sm text-od-content-primary">
              {ctaTitle}
            </Text>
          )}
          <Text as="span" className="block text-body-sm text-od-content-secondary">
            {ctaLink.name}
          </Text>
        </Col>
        <Text as="span" className="text-body-sm text-od-content-primary">
          <IconChevronRight size={24} aria-hidden="true" />
        </Text>
      </Row>
    </Col>
  );
};
